"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeimosDown = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
const CardRenderer_1 = require("../render/CardRenderer");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Resources_1 = require("../../Resources");
const Units_1 = require("../../Units");
class DeimosDown extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.DEIMOS_DOWN,
            tags: [Tags_1.Tags.SPACE],
            cost: 31,
            tr: { temperature: 3 },
            metadata: {
                cardNumber: '039',
                description: 'Raise temperature 3 steps and gain 4 steel. Remove up to 8 Plants from any player.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.temperature(3).br;
                    b.steel(4).br;
                    b.minus().plants(-8).any;
                }),
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        else {
            this.howToAffordReds = undefined;
            return true;
        }
    }
    play(player) {
        player.game.increaseTemperature(player, 3);
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 8));
        player.addResource(Resources_1.Resources.STEEL, 4);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(3) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, temperatureIncrease: 3, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.DeimosDown = DeimosDown;
//# sourceMappingURL=DeimosDown.js.map